import { EGetLkTypeStatus } from '../../actions/lkType';
import { ELkType } from '../../repositories/lk-type/entities/get_lk_type_v2/GetLkTypeResponseV2';
import { TReduxActions } from '../../types/redux';

export function lkTypeReducer(state: ELkType | null = null, action: TReduxActions): ELkType | null {
  if (action.type === EGetLkTypeStatus.Succeed) {
    return action.payload;
  }

  return state;
}
